import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { CloseOutlined } from '@ant-design/icons';
import { Button, Input, Modal, Spin } from 'antd';

import { useListPostback, useUpdatePostback } from 'v2/hooks/campaigns';

interface IProps {
  open: boolean;
  product: any;
  onClose: any;
}

const PostbackModal: React.FC<IProps> = ({ open, product, onClose }) => {
  const [postbackUrl, setPostbackUrl] = useState('');

  const { data: postbackData, isLoading: isLoadingPostback } = useListPostback(product.id, 'POSTBACK', 'URL');
  const updatePostbackMutation = useUpdatePostback();

  useEffect(() => {
    if (postbackData?.data?.length > 0) {
      setPostbackUrl(postbackData.data[0].script);
    }
  }, [postbackData?.data]);

  const handleSubmit = useCallback(async () => {
    try {
      await updatePostbackMutation.mutateAsync({
        productId: product.id,
        script: postbackUrl,
        destiny: 'POSTBACK',
        type: 'URL'
      });
      toast.success('Url de postback atualizada!');

      if (onClose) {
        onClose();
      }
    } catch (error) {
      toast.error('Ops, erro ao atualizar a url de postback!');
    }
  }, [product.id, postbackUrl, onClose, updatePostbackMutation]);

  const isBusy = isLoadingPostback || updatePostbackMutation.isPending;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={<span style={{ color: '#192542' }}>URL de Postback</span>}
      width={640}
      footer={
        <div className='flex items-center justify-end gap-2'>
          <Button disabled={isBusy} onClick={onClose}>
            Fechar
          </Button>
          <Button type='primary' danger disabled={isBusy} onClick={handleSubmit} className='ml-2'>
            Salvar
          </Button>
        </div>
      }
    >
      <p>
        O recurso de postback permite que você receba notificações de alguns eventos que ocorrem dentro do sistema,
        possibilitando que além do produtor, o afiliado também tenha um melhor controle sobre seu negócio.{' '}
        <a target='_blank' rel='noopener noreferrer' href='https://github.com/eduzz/postback'>
          <strong>Saiba mais</strong>
        </a>
      </p>

      <div className='mt-8' />

      <Input
        value={postbackUrl}
        onChange={(e: any) => setPostbackUrl(e.target.value)}
        placeholder='Ex: http://www.meusite.com/postback'
        prefix={<span className='text-gray-500'>URL</span>}
        suffix={
          isBusy ? (
            <Spin size='small' />
          ) : (
            <Button type='text' size='small' onClick={() => setPostbackUrl('')} icon={<CloseOutlined />} />
          )
        }
      />
    </Modal>
  );
};

export default PostbackModal;
